import { http } from '@/plugins/http';

/* eslint-disable import/prefer-default-export */
export function fetchPolicy({ dispatch }, policyPath) {
  return http.get(`/${policyPath}`)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching policy:', err);
      return Promise.reject(err);
    });
}



// WEBPACK FOOTER //
// ./src/app/policies/store/actions.js